/**
 * The round icons of the waiting screen and of the interruption (#7) that the self-hosted icon
 * font does not carry (`lib/icones-police.ts`, a 21-icon subset): drawn as inline SVG, in the
 * same 24 px box and 2 px round strokes as the ones of the history page, `currentColor`.
 * Adding them to the font would be the other way (see `scripts/subset-icons.py`, which needs
 * `fonttools`).
 */
export const ICONES_TRAIT = ['stop_circle', 'check_circle', 'radio_button_unchecked'] as const;
export type NomIconeTrait = (typeof ICONES_TRAIT)[number];

interface IconeTraitProps {
  name: NomIconeTrait;
  /** Size in pixels; 24 when omitted. */
  size?: number;
  className?: string;
}

function dedans(name: NomIconeTrait) {
  switch (name) {
    case 'stop_circle':
      return <rect x="9" y="9" width="6" height="6" rx="1" />;
    case 'check_circle':
      return <path d="m8.5 12.5 2.5 2.5 4.5-5" />;
    case 'radio_button_unchecked':
      return null;
  }
}

/** Decorative icon: the label belongs to the control, or the text, that holds it. */
export function IconeTrait({ name, size = 24, className }: IconeTraitProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      data-icone={name}
    >
      <circle cx="12" cy="12" r="9" />
      {dedans(name)}
    </svg>
  );
}
